module.exports = __webpack_public_path__ + "08c5cfeb892b7af58843b706864e581b.png";